import { render } from "./CallModal.vue?vue&type=template&id=2fb516ad"
import script from "./CallModal.vue?vue&type=script&lang=js"
export * from "./CallModal.vue?vue&type=script&lang=js"

import "./CallModal.vue?vue&type=style&index=0&id=2fb516ad&lang=scss"
script.render = render

export default script